// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__2jqWW","buttons":"Password_buttons__3ONBO"};